import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../core/services/header.service';
import { Title } from '@angular/platform-browser';
import { BaseComponent } from '../../core/base.component';
import { AuthService } from '../../core/security/auth.service';
import { NotificationService } from '../../notification/notification.service';
import { FilterOptionModel } from '../../dialogs/grid-filter/filter-option.model';
import { RolesEnum } from '../../core/security/roles.enum';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { EventsFlowGridComponent } from '../grid/events-flow-grid.component';

@Component({
  selector: 'app-events-flow-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: true,
  imports: [
    FlexModule,
    GridFilterComponent,
    FilterRowAdditionalContentComponent,
    NgIf,
    MatButton,
    MatTooltip,
    EventsFlowGridComponent,
  ],
})
export class EventsFlowListComponent extends BaseComponent implements OnInit, OnDestroy {
  filterChangeEvent = new EventEmitter<any>();
  filterOptions: FilterOptionModel[] = [];
  detailsUrl: string;

  constructor(
    route: ActivatedRoute,
    headerService: HeaderService,
    titleService: Title,
    public authService: AuthService,
    private router: Router,
    public notificationService: NotificationService,
  ) {
    super(route, headerService, titleService, authService);
    this.detailsUrl = '../edit';
    this.editRoles = [RolesEnum.Support];
    this.deleteRoles = [RolesEnum.Support];
  }

  ngOnInit() {
    console.log('on init');
    super.ngOnInit();

    this.initFilterOptions();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onCreateNewEventsFlow() {
    this.router.navigate([this.detailsUrl, 'new'], { relativeTo: this.route });
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any',
      },
      {
        filterKey: 'enabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Is Enabled',
        displayValue: 'Yes',
        value: true,
        searchText: 'Is Enabled: Yes',
      },
      {
        filterKey: 'enabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Is Enabled',
        displayValue: 'No',
        value: false,
        searchText: 'Is Enabled: No',
      },
    ];
  }
}
